import { useMemo } from 'react';

import { Badge } from '../../components';
import { useAppContext } from '../../shared';
import Routes, { getRoutes } from '../Routes';
import Layout, { Menu, UserBar, Collapser } from '../Layout';

const Content = () => {
  const { loading, meta, title } = useAppContext();
  const routes = useMemo(() => getRoutes(meta), [meta]);

  if (loading) return null;

  const collapser = <Collapser />;
  const menuElement = <Menu items={routes} />;
  const titleElement = !!title && (
    <header className="min-w-[20rem] basis-1/2 grow-0 shrink border-b border-active">
      <div className="font-medium text-title flex flex-row items-center justify-start gap-x-sm h-full">
        {typeof title === 'string' && <Badge text={title || ''} shrink />}
        <div
          className="truncate"
          title={typeof title === 'string' ? title : ''}
        >
          {title}
        </div>
      </div>
    </header>
  );
  const userElement = <UserBar />;

  return (
    <Layout
      menu={menuElement}
      user={userElement}
      title={titleElement}
      collapser={collapser}
    >
      {<Routes routes={routes} />}
    </Layout>
  );
};

export default Content;
